/* Meirelle v6 - PDP model (Birkenstock-like layout). Loaded from footer-group on product pages. */
(function () {
  if (window.__mmPdp) return;
  window.__mmPdp = 1;

  function handleOf() {
    return (location.pathname.split('/products/')[1] || '').split('?')[0];
  }
  function kind(h) {
    if (/^maibulun-suede-sandal/.test(h)) return 'suede';
    if (/^maibulun-leather-sandal/.test(h)) return 'leather';
    if (/^clog/.test(h)) return 'clog';
    if (/^salerno/.test(h)) return 'salerno';
    return '';
  }
  var SUB = { suede: 'Two-strap footbed sandal', leather: 'Two-strap footbed sandal', clog: 'Slip-on footbed clog', salerno: 'Footbed sandal' };
  function subOf(h) {
    return SUB[kind(h)] || '';
  }

  /* ---- materials (source: original seller listing of this catalogue - synthetic suede / synthetic leather, EVA sole) ---- */
  var UPPER = { suede: 'Faux suede (synthetic)', leather: 'Faux leather (synthetic)', clog: 'Faux suede (synthetic)', salerno: 'Faux suede (synthetic)' };
  var CLOSURE = {
    suede: 'Slip-on, two adjustable buckle straps',
    leather: 'Slip-on, two adjustable buckle straps',
    clog: 'Slip-on, adjustable buckle strap',
    salerno: 'Adjustable straps with metal buckles'
  };
  var CARE =
    '<ul><li>Wipe clean with a <strong>soft, slightly damp cloth</strong>.</li>' +
    '<li>Avoid soaking and frequent wetting.</li>' +
    '<li>Let them <strong>dry naturally in the shade</strong>, away from direct heat and sunlight.</li></ul>';

  function accByTitle(sec, name) {
    var list = sec.querySelectorAll('.product__accordion');
    for (var i = 0; i < list.length; i++) {
      var t = list[i].querySelector('.accordion__title');
      if (t && t.textContent.trim().toLowerCase().indexOf(name) === 0) return list[i];
    }
    return null;
  }

  function pdp() {
    var sec = document.querySelector('.shopify-section[id$=__main]');
    if (!sec || !sec.querySelector('product-info')) return;
    var h1 = sec.querySelector('.product__title h1');
    if (!h1 || h1.getAttribute('data-mm')) return;
    h1.setAttribute('data-mm', '1');
    var h = handleOf();
    var k = kind(h);

    /* title + subtitle (model name / descriptor), colour stays in the swatch label (the head script normally did this already) */
    var parts = h1.textContent.trim().split(' - ');
    if (parts.length > 1) h1.textContent = parts[0];
    if (!sec.querySelector('.mm-sub')) {
      var sub = document.createElement('p');
      sub.className = 'mm-sub';
      sub.textContent = subOf(h);
      var box = h1.closest('.product__title') || h1;
      box.parentNode.insertBefore(sub, box.nextSibling);
    }

    if (k) {
      /* care - shoe-specific wording */
      var c = accByTitle(sec, 'care');
      if (c) {
        var cc = c.querySelector('.accordion__content');
        if (cc) cc.innerHTML = CARE;
      }
      /* materials & details */
      if (!sec.querySelector('.mm-acc')) {
        var data = [
          ['Upper', UPPER[k]],
          ['Footbed', 'Cushioned footbed'],
          ['Sole', 'EVA'],
          ['Closure', CLOSURE[k]]
        ];
        var rows = data
          .map(function (r) {
            return '<div><dt>' + r[0] + '</dt><dd>' + r[1] + '</dd></div>';
          })
          .join('');
        var wrap = document.createElement('div');
        wrap.className = 'mm-acc';
        wrap.innerHTML =
          '<details><summary><span>Materials &amp; details</span><i aria-hidden="true"></i></summary><dl>' + rows + '</dl></details>';
        var accs = sec.querySelectorAll('.product__accordion');
        var d0 = accByTitle(sec, 'description') || accs[0];
        if (d0) d0.parentNode.insertBefore(wrap, d0.nextSibling);
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pdp);
  else pdp();
  var sec = document.querySelector('.shopify-section[id$=__main]');
  if (sec) new MutationObserver(pdp).observe(sec, { childList: true, subtree: true });
})();